import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as BackupLimitsAction from '../actions/backup-limits.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, switchMap} from 'rxjs/operators';
import {ProductService} from "../../websites/website/product.service";
import {UserService} from "../../user/user.service";

@Injectable()
export class BackupLimitsEffect {

  constructor(
    private _actions$: Actions,
    private _productService: ProductService,
    private _userService: UserService
  ) {
  }

  /*@Effect() loadUserSuccess$ = this._actions$.ofType(userActions.LOAD_USER_SUCCESS)
    .pipe(
      filter((action: LoadUserSuccess) => !!action.payload),
      switchMap(() => {
        return this._userService.getUserSubscription()
          .pipe(
            filter((response: DbResponse) => !!response),
            map((response: DbResponse) => {
              if (response.success && response.data && response.data.status !== 'expired') {
                return new BackupLimitsAction.LoadBackupLimits();
              }
              return new BackupLimitsAction.LoadBackupLimitsFail("There is no active agreement");
            })
          );
      })
    );*/

  loadBackupLimits$ = createEffect(() => this._actions$.pipe(
    ofType(BackupLimitsAction.LOAD_BACKUP_LIMITS),
    switchMap(() => {
      return this._productService.getBackupLimit()
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new BackupLimitsAction.LoadBackupLimitsSuccess(response.data);
            }
            return new BackupLimitsAction.LoadBackupLimitsFail(response.message);
          })
        );
    })
  ));


}
